import { render, staticRenderFns } from "./the-system.vue?vue&type=template&id=f311306e&scoped=true&"
import script from "./the-system.vue?vue&type=script&lang=js&"
export * from "./the-system.vue?vue&type=script&lang=js&"
import style0 from "./the-system.vue?vue&type=style&index=0&id=f311306e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f311306e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeroSection: require('/opt/build/repo/apps/shop/components/HeroSection.vue').default,Video: require('/opt/build/repo/apps/shop/components/storyblok/Video/Video.vue').default,SplitView: require('/opt/build/repo/apps/shop/components/storyblok/SplitView/SplitView.vue').default,FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
